import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { api } from '../../api/config';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
// import InputLabel from '@mui/material/InputLabel';
import Typography from '@mui/material/Typography';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import FormControl from '@mui/material/FormControl';
import { isFormValid, validateValue } from '../../services/Regex';
// import DatePickerSeperate from '../../components/DatePickerSeperate';
import { Link } from 'react-router-dom';
import { InputAdornment, OutlinedInput } from '@mui/material';


const inputStyle = {
    '& .MuiOutlinedInput-root': {
        color: '#728085',

        '& fieldset': {
            borderColor: '#728085',
            borderRadius: '0px',
            borderWidth: '1px',
        },
        '&:hover fieldset': {
            borderColor: '#728085',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#728085',
        },
        '&.Mui-error fieldset': {
            borderColor: '#d32f2f !important',
        },
    },

    '& input::placeholder': {
        color: '#728085',
        opacity: 1,
    },

    '& textarea::placeholder': {
        color: '#728085',
        opacity: 1,
    },
};

export default function BookNow() {

    const years = new Date().getFullYear();

    const [client, setClient] = React.useState({
        firstname: '',
        lastname: '',
        gender: '',
        dob: { day: "01", month: "01", year: years },
        mobile: '',
        email: '',
        bookDate: { day: "01", month: "01", year: years },
        treatment: '',
        message: '',
        privacyTerms: false
    });
    const [errors, setErrors] = React.useState({
        firstname: false,
        lastname: false,
        gender: false,

        dobDay: false,
        dobMonth: false,
        dobYear: false,

        mobile: false,
        email: false,

        bookDateDay: false,
        bookDateMonth: false,
        bookDateYear: false,

        treatment: false,
        message: false,
        privacyTerms: false
    });

    const errorHandler = {
        onFirstName: (e) => {
            var value = e.target.value;
            setErrors({ ...errors, firstname: validateValue(value, /^[a-zA-Z]+$/) });
            setClient({ ...client, firstname: value });
        },
        onLastName: (e) => {
            var value = e.target.value;
            setErrors({ ...errors, lastname: validateValue(value, /^[a-zA-Z]+$/) });
            setClient({ ...client, lastname: value });
        },
        onGender: (e) => {
            var value = e.target.value;
            setErrors({ ...errors, gender: validateValue(value, /^(M|F)$/) });
            setClient({ ...client, gender: value });
        },
        // Date Of Birth
        onDobDay: (e) => {
            var value = e.target.value;
            setErrors({ ...errors, dobDay: validateValue(value, /^\d+$/) });
            setClient({ ...client, dob: { ...client.dob, day: value } });
        },
        onDobMonth: (e) => {
            var value = e.target.value;
            setErrors({ ...errors, dobMonth: validateValue(value, /^\d+$/) });
            setClient({ ...client, dob: { ...client.dob, month: value } });
        },
        onDobYear: (e) => {
            var value = e.target.value;
            setErrors({ ...errors, dobYear: validateValue(value, /^\d+$/) });
            setClient({ ...client, dob: { ...client.dob, year: value } });
        },
        // Date Of Birth
        onMobile: (e) => {
            var value = e.target.value;
            setErrors({ ...errors, mobile: validateValue(value, /^(?:\+?(\d{1,3}))?[\s.-]?\(?\d+\)?[\s.-]?\d+[\s.-]?\d+$/) });
            setClient({ ...client, mobile: value });
        },
        onEmail: (e) => {
            var value = e.target.value;
            setErrors({ ...errors, email: validateValue(value, /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/) });
            setClient({ ...client, email: value });
        },
        // Book Date
        onBookDay: (e) => {
            var value = e.target.value;
            setErrors({ ...errors, bookDateDay: validateValue(value, /^\d+$/) });
            setClient({ ...client, bookDate: { ...client.bookDate, day: value } });
        },
        onBookMonth: (e) => {
            var value = e.target.value;
            setErrors({ ...errors, bookDateMonth: validateValue(value, /^\d+$/) });
            setClient({ ...client, bookDate: { ...client.bookDate, month: value } });
        },
        onBookYear: (e) => {
            var value = e.target.value;
            setErrors({ ...errors, bookDateYear: validateValue(value, /^\d+$/) });
            setClient({ ...client, bookDate: { ...client.bookDate, year: value } });
        },
        // Book Date

        onTreatment: (e) => {
            var value = e.target.value;
            setErrors({ ...errors, treatment: validateValue(value) });
            setClient({ ...client, treatment: value });
        },
        onMessage: (e) => {
            var value = e.target.value;
            setErrors({ ...errors, message: validateValue(value, /^[a-zA-Z]+$/) });
            setClient({ ...client, message: value });
        },
        onCheck: (e) => {
            var value = e.target.checked;
            setErrors({ ...errors, privacyTerms: value === true ? false : true });
            setClient({ ...client, privacyTerms: value });
        }
    };

    const handleRequest = () => {
        var valid = isFormValid(errors);
        if (valid) {
            api.post('reservation/request_appointment', client)
                .then((res) => {
                    console.log(res);
                })
                .catch(err => {
                    console.log("Error: ", err);
                })
        } else {

        }
    }

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingTop: { md: '100px', xs: '50px' }, flexDirection: 'column', gap: { md: '130px', xs: '50px' } }}>
            <Box width={{ lg: '800px', sm: '80%', xs: '90%' }} marginX={'auto'}>
                <Grid container>
                    <Grid size={12}>
                        <Grid container spacing={2}>
                            <Grid width={{ md: '478px', xs: '100%' }} mx={'auto'}>
                                <Typography textAlign={'center'} variant="h1" fontFamily={'DanmarkURW'} className='dColor' fontSize={'2.875rem'} fontWeight={'bold'}>REQUEST A  <br /> CONSULTATION</Typography>
                                <Typography variant="body1" mt={'20px'} textAlign={'center'} className='dColor' fontSize={'22px'} sx={{ a: { color: 'text.secondary' } }}>Please fill in the form below or call <a href="tel:+38349909090">+383 49 909 090</a> or email <a href="mailto:info@rinu.me">info@rinu.me</a> to speak to our clinic team about a booking enquiry.</Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={12} mt={'24px'}>
                        <Grid container spacing={2}>
                            <Grid size={12}>
                                <Grid container spacing={2}>
                                    <Grid size={12}>
                                        <Grid container spacing={2}>
                                            <Grid size={{ md: 6, xs: 12 }}>
                                                <Box sx={inputStyle}>
                                                    <TextField fullWidth placeholder='First Name*' value={client.firstname} onChange={(e) => errorHandler.onFirstName(e)} error={errors.firstname} />
                                                </Box>
                                            </Grid>
                                            <Grid size={{ md: 6, xs: 12 }}>
                                                <Box sx={inputStyle}>
                                                    <TextField fullWidth placeholder='Surname*' value={client.lastname} onChange={(e) => errorHandler.onLastName(e)} error={errors.lastname} />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid size={12}>
                                        <Grid container spacing={2}>
                                            <Grid size={{ md: 6, xs: 12 }}>
                                                <Box sx={inputStyle}>
                                                    <TextField fullWidth type="date" />
                                                </Box>

                                            </Grid>
                                            <Grid size={{ md: 6, xs: 12 }}>
                                                <Box sx={inputStyle}>
                                                    <TextField fullWidth placeholder='Phone' value={client.mobile} onChange={(e) => errorHandler.onMobile(e)} error={errors.mobile} />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid size={12}>
                                        <Grid container spacing={3}>
                                            <Grid size={{ md: 6, xs: 12 }}>
                                                <Box sx={inputStyle}>
                                                    <TextField fullWidth placeholder='E-Mail' value={client.email} onChange={(e) => errorHandler.onEmail(e)} error={errors.email} />
                                                </Box>
                                            </Grid>
                                            <Grid size={{ md: 6, xs: 12 }}>
                                                <Box sx={inputStyle}>
                                                    <FormControl fullWidth sx={inputStyle}>
                                                        <Select value={""} displayEmpty sx={{ color: '#728085' }}>
                                                            <MenuItem value="" sx={{ color: '#728085' }}>
                                                                Gender
                                                            </MenuItem>
                                                            <MenuItem value={10} sx={{ color: '#728085' }}>Male</MenuItem>
                                                            <MenuItem value={20} sx={{ color: '#728085' }}>Female</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid size={12}>
                                        <Grid container spacing={3}>
                                            <Grid size={{ md: 6, xs: 12 }}>
                                                <Box sx={inputStyle}>
                                                    <FormControl fullWidth sx={inputStyle}>
                                                        <Select value={""} displayEmpty sx={{ color: '#728085' }}>
                                                            <MenuItem value="" sx={{ color: '#728085' }}>
                                                                Select a Treatment
                                                            </MenuItem>
                                                            <MenuItem value={10} sx={{ color: '#728085' }}>Male</MenuItem>
                                                            <MenuItem value={20} sx={{ color: '#728085' }}>Female</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Box>
                                            </Grid>
                                            <Grid size={{ md: 6, xs: 12 }}>
                                                <Box sx={inputStyle}>
                                                    <FormControl fullWidth sx={inputStyle}>
                                                        <Select value={""} displayEmpty sx={{ color: '#728085' }}>
                                                            <MenuItem value="" sx={{ color: '#728085' }}>
                                                                Prefered Contact Method
                                                            </MenuItem>
                                                            <MenuItem value={10} sx={{ color: '#728085' }}>E-Mail</MenuItem>
                                                            <MenuItem value={20} sx={{ color: '#728085' }}>Phone Number</MenuItem>
                                                        </Select>
                                                    </FormControl>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid size={12}>
                                        <Grid container spacing={3}>

                                            <Grid size={{ md: 12, xs: 12 }}>
                                                <Box sx={inputStyle}>
                                                    <TextField
                                                        multiline
                                                        fullWidth
                                                        placeholder='Comment'
                                                        value={client.message}
                                                        error={errors.message}
                                                        onChange={(e) => errorHandler.onMessage(e)}
                                                    />
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    <Grid size={12}>
                                        <Grid container>
                                            <Grid size={12}>
                                                <Box display={'flex'} alignItems={'center'} sx={{ svg: { fill: '#728085' } }}>
                                                    <Checkbox disableFocusRipple disableRipple disableTouchRipple sx={{ paddingLeft: 0 }} value={client.privacyTerms} onChange={(e) => errorHandler.onCheck(e)} />
                                                    <Typography variant="body2" className={'dColor'} sx={{ a: { color: 'text.secondary' } }}>To keep you up to date with RINU's latest offers, products & services via email simply select the tick box. You can unsubscribe at any time.</Typography>
                                                </Box>
                                            </Grid>
                                            <Grid size={12}>
                                                <Box display={'flex'} alignItems={'center'} sx={{ svg: { fill: '#728085' } }}>
                                                    <Checkbox disableFocusRipple disableRipple disableTouchRipple sx={{ paddingLeft: 0 }} value={client.privacyTerms} onChange={(e) => errorHandler.onCheck(e)} />
                                                    <Typography variant="body2" className={'dColor'} sx={{ a: { color: 'text.secondary' } }}>To sign-up to our SMS community, please tick the box. You can unsubscribe at any time.</Typography>
                                                </Box>
                                            </Grid>
                                            <Grid size={12}>
                                                <Box display={'flex'} alignItems={'center'} sx={{ svg: { fill: '#728085' } }}>
                                                    <Checkbox disableFocusRipple disableRipple disableTouchRipple sx={{ paddingLeft: 0 }} value={client.privacyTerms} onChange={(e) => errorHandler.onCheck(e)} />
                                                    <Typography variant="body2" className={'dColor'} sx={{ a: { color: 'text.secondary' } }}>I Accept The <Box component={Link} sx={{ color: 'blue!important' }} to="/policy">Privacy Policy</Box> And T&C's*</Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                    {/* <Grid size={12} mt={'40px'}>
                                        <Box className="flexCenter">
                                            <Button variant='outlined' className='borderRadiusFlat borderWidth2 buttonPaddingY10 defaultBorderColor' sx={{ backgroundColor: 'text.secondary', color: 'text.primary', width: {md: '376px', xs: '90%'}, maxHeight: '50px', height: '50px' }} onClick={() => handleRequest()}>BOOK NOW</Button>
                                        </Box>
                                    </Grid> */}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Button variant='contained' sx={{ background: '#1E353D', borderRadius: 0, borderWidth: '2px', color: '#FFF', fontSize: '1.125rem', width: '166px', textTransform: 'none', boxShadow: 'none' }}>
                        Submit
                    </Button>
                </Box>
            </Box>

            <Box bgcolor={'text.secondary'} paddingTop={{ md: '80px', xs: '50px' }} paddingBottom={{ md: '80px', xs: '50px' }} width={1}>
                <Grid container>
                    <Grid size={{ md: 6, xs: 11 }} marginX={'auto'} bgcolor={'#FFF'}>
                        <Grid container padding={{ md: '100px', xs: '20px' }} justifyContent={'center'}>
                            <Grid size={12}>
                                <Typography variant="h5" color="text.secondary" fontSize={{ md: '26px', xs: '1rem' }} fontWeight={'bold'} textAlign={'center'}>JOIN OUR SKIN HEALTH CONVERSATION & GET 10% OFF SKINCARE ON YOUR FIRST ORDER*</Typography>
                            </Grid>
                            <Grid size={{ md: 10, xs: 12 }} marginTop={{ md: '35px', xs: '20px' }}>
                                <OutlinedInput sx={{ borderRadius: '40px', color: '#000', '.MuiOutlinedInput-notchedOutline': { borderColor: '#1E353D !important', borderStyle: 'solid !important', borderWidth: '1px !important' } }} endAdornment={<InputAdornment position="end"><ArrowForwardIosIcon /></InputAdornment>} fullWidth placeholder='Email Address' />
                            </Grid>
                            <Grid size={{ md: 10, xs: 12 }} marginTop={{ md: '31px', xs: '20px' }}>
                                <Box className="alignItemsCenter">
                                    <Checkbox color='text.secondary' sx={{ paddingLeft: 0 }} />
                                    <Typography variant="body1" color="text.secondary" sx={{ a: { color: '#1E353D' } }}>I Accept The <Box component={Link} to="/policy">Privacy Policy</Box> And T&C's</Typography>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Box>

        </Box>
    )
}